import { Box, Skeleton } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Plus, Wallet } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import SectionInfo from 'modules/expenses/pages/settings/ExpensePolicy/Components/_SectionInfo'

const ExpensesApprovalWorkflow = () => {
  return (
    <Box flexDirection="column" gap="s24" paddingX="s24" flexGrow>
      <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween" gap="s12">
        <SectionInfo
          icon={Wallet}
          title={i18n.t('expenses_v2.settings.expense_policy.approval_workflows')}
        />
        <F0Button variant="outline" disabled label="Add approval workflow" icon={Plus} />
      </Box>

      <Box flexDirection="column" gap="s16">
        <Skeleton height="s64" isLoading />
      </Box>
    </Box>
  )
}

export default ExpensesApprovalWorkflow
